import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-registration-complete',
  templateUrl: './registration-complete.component.html',
  styleUrls: ['./registration-complete.component.scss']
})
export class RegistrationCompleteComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }
  redirectLogin(): void {
    this.router.navigate(['/login']);
  }

}
